/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.MembershipManager {
    angular.module("meevo.plugins.membershipManager", []);
}